import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { projectInfo } from '../config';
import { HeroSection } from "./pages/home/hero-section/hero-section";
import { Footer } from "./shared/footer/footer";
import { ComingSoon } from "./pages/home/coming-soon/coming-soon";
import { Technologies } from "./pages/home/technologies/technologies";
import { WhyChooseUs } from "./pages/home/why-choose-us/why-choose-us";
import { WhatIsSchema } from "./pages/home/what-is-schema/what-is-schema";
import { HeaderComponent } from "./shared/header/header";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeroSection, Footer, ComingSoon, Technologies, WhyChooseUs, WhatIsSchema, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'] 
})
export class AppComponent {
  title = projectInfo.name;
  description = projectInfo.description;
  private titleService = inject(Title);

  constructor() {
    this.titleService.setTitle(this.title + ' | ' + this.description);
  }

  setTitle(title: string, description: string) {
    this.title = title;
    this.description = description;
  }
}
